import React, { useCallback } from 'react';
import * as slice from "../../store/IRGrading/IRGradingSlice";
import { useAppDispatch, useAppSelector } from "../../store/hook";
import { irGradeAction } from '../../store/IRGrading/IRGradingSlice';

export const useIRGrade = () => {
    const dispatch = useAppDispatch();
    return {
        loadGradeMap: useCallback((payload) => {
            dispatch(irGradeAction.loadGradeMapping(payload));
        }, [dispatch]),
        loadCurrent: useCallback((payload) => {
            dispatch(irGradeAction.loadCurrentGradeMapping(payload));
        }, [dispatch]),
        save: useCallback((payload) => {
            dispatch(irGradeAction.saveCurrentGradeMapping(payload));
        }, [dispatch]),
        create: useCallback((payload) => {
            dispatch(irGradeAction.createGradeMapping(payload));
        }, [dispatch]),
        remove: useCallback((payload) => {
            dispatch(irGradeAction.deleteGradeMapping(payload));
        }, [dispatch]),
        loadCourseMapping: useCallback((payload) => {
            dispatch(irGradeAction.loadCourseMapping(payload));
        }, [dispatch]),
        loadCourseMappingV2: useCallback((payload) => {
            dispatch(irGradeAction.loadCourseMappingV2(payload));
        }, [dispatch]),
        loadAllGrades: useCallback((payload) => {
            dispatch(irGradeAction.loadAllGrades(payload))
        }, [dispatch]),
        loadLevels: useCallback((payload) =>{
            dispatch(irGradeAction.loadLevels(payload))
        },[dispatch]),
        addLevel: useCallback((payload) =>{
            dispatch(irGradeAction.addLevel(payload));
        },[dispatch]),
        deleteLevel: useCallback((levelId) => {
            dispatch(irGradeAction.deleteLevel(levelId));
        }, [dispatch]),


        gradingList: useAppSelector(slice.getGradeMapping),
        courseMappingList: useAppSelector(slice.getCourseMapping),
        courseMappingListV2: useAppSelector(slice.getCourseMappingV2),
        current: useAppSelector(slice.getCurrentGradeMapping),
        loading: useAppSelector(slice.isLoading),
        pagination: useAppSelector(slice.getPagination),
        index: useAppSelector(slice.currentIndex),
        grades: useAppSelector(slice.getGrades),
        levelsList: useAppSelector(slice.getLevels)
    }
}